// Mixins
import { GoogleAnalyticsMixins } from "@/app/mixins/utils/google-analytics-mixins";
import { comingSoonMixins } from "@/app/mixins/utils/coming-soon-mixins";

// Utils
import { GA } from "@/app/constants/ga-constants";

export default {
    name: "SubscribeNowOverlay",
    mixins: [GoogleAnalyticsMixins, comingSoonMixins],
    props: {
        page: {
            default: "",
        },
    },
    data() {
        return {
            subscribeText: "Subscribe to monitor and get alerts regarding your pet's health",
        };
    },
    created() {
        if (this.page === "Tracking") {
            this.subscribeText = "Subscribe to monitor your pet's location";
        }
    },
    methods: {
        sendSubscribeNowAnalytics() {
            switch (this.page) {
                case "Tracking":
                    this.$router.push(`/products/product-list?type=${this.page}`);
                    break;

                case "Health":
                    this.$store.commit("setComingSoon", "Exercise");
                    this.showComingSoonAlert();
                    break;

                default:
                    this.$router.push("/products/product-list");
            }

            this.sendEventTrackingToGA(
                GA.DASHBOARD_PAGE.SUBSCRIBE_NOW_CARDS.ACTION,
                GA.DASHBOARD_PAGE.CATEGORY,
                GA.DASHBOARD_PAGE.SUBSCRIBE_NOW_CARDS.LABEL
            );
        },
    },
};
